import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

const RefundPolicy = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />

      <main className="max-w-2xl mx-auto px-4 py-12">
        <h1 className="text-2xl font-bold text-gray-900 mb-2 text-center">
          Refund Policy
        </h1>
        <p className="text-sm text-gray-600 mb-12 text-center leading-relaxed">
          Thank you for your registration to Aqua India 2026 organized by
          Society of Aquaculture Professionals.
        </p>

        <div className="space-y-8">
          <section>
            <h2 className="text-lg font-semibold text-gray-900 mb-4 border-b border-gray-300 pb-1">
              Payment Requirements
            </h2>
            <div className="text-sm text-gray-700 leading-relaxed">
              All registrations require full payment to confirm participation.
            </div>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mb-4 border-b border-gray-300 pb-1">
              Refund Rules
            </h2>
            <div className="space-y-2 text-sm text-gray-700 leading-relaxed">
              <div>• No refunds once paid under any circumstances</div>
              <div>
                • (including schedule changes, personal decisions, travel
                issues, etc.)
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mb-4 border-b border-gray-300 pb-1">
              Transfer Option
            </h2>
            <div className="text-sm text-gray-700 leading-relaxed">
              Transfer of registration to another participant may be considered
              upon written request and subject to approval.
            </div>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mb-4 border-b border-gray-300 pb-1">
              Event Cancellation
            </h2>
            <div className="text-sm text-gray-700 leading-relaxed">
              If the event is fully canceled by organizers, an alternative
              arrangement or credit may be offered at the sole discretion of
              SAP.
            </div>
          </section>
        </div>

        <div className="mt-16 pt-8 border-t border-gray-200 text-center">
          <p className="text-sm font-medium text-gray-900 leading-relaxed">
            By registering, you acknowledge and agree to this Refund Policy.
          </p>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default RefundPolicy;
